import React, { useState, useContext } from "react";
import Footer from "../component/Footer";
import Navbar from "../component/Navbar";
import { Link } from "react-router-dom";

function Bookappointment() {
  const pickedTherapist = JSON.parse(localStorage.getItem("pickedTherapist"));

  // console.log(selectedTherapist);

  const [appointmentTime, setAppointmentTime] = useState("");
  function setAppointment() {
    const therapistsURL = "https://thrive-mqy3.onrender.com/v1/therapists";
    const requestData = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    fetch(therapistsURL, requestData)
      .then((res) => res.json())
      .then((data) => console.log(data));
    // console.log(appointmentTime);
  }

  return (
    <div className="bg-[#D9D9D9]">
      <Navbar />
      <div>
        <h1 className="text-[#295700] text-xl font-semibold text-center py-8 md:border-b-2 border-[#295700] md:mb-8">
          BOOK APPOINTMENT
        </h1>
        <div className="md:flex justify-center gap-6">
          <div className="md:w-[45%]" id="therapistContainer">
            <div class="bg-white p-2 mx-4 rounded-md">
              <div class="flex gap-4 items-center px-4 py-6">
                <img
                  src={
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU"
                  }
                  alt="man"
                  class="w-28 h-28 rounded-full object-cover"
                />
                <div>
                  <p class="uppercase text-[#295700] text-xl font-semibold mb-4s">
                    {pickedTherapist.user.lastName} &nbsp;
                    {pickedTherapist.user.firstName}
                  </p>
                  <p class="text-[#295700]">Degree: BSc MBBS</p>
                  <p class="text-[#295700]">
                    Specialty: {pickedTherapist.specialization}, &nbsp;
                    {pickedTherapist.location
                      ? pickedTherapist.location
                      : "Kano"}
                    .
                  </p>
                  {/* <div class="flex gap-4 mt-2">
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1700642922/gbgbhkh71ly1zvmdefwz.png"
                      alt="call"
                      class="w-4 h-4"
                    />
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1700642948/hgfskhu5faxcbfy932ec.png"
                      alt="message"
                      class="w-4 h-4"
                    />
                  </div> */}
                </div>
              </div>
              <p class="mt-2 mb-2 text-[#295700] px-10 font-bold text-2xl">
                Bio
              </p>
              <p class="text-[#295700] mb-2 px-4">{pickedTherapist.bio}</p>
            </div>
          </div>
          {/* <div className="md:w-[45%] mt-6 md:mt-0 px-4 pb-8">
            <iframe
              src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Africa%2FLagos&showTitle=0&showPrint=0&showTabs=0&showCalendars=0&src=MjAwYzI0N2UxMjRmMmY2ODE2MjU5ZDk1ZDIzYzEyNmZiMjliY2ZlYmYxMzcyYzIyYjUwOGYyN2YyMDAwYWFlOUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ZW4ubmcjaG9saWRheUBncm91cC52LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23009688&color=%230B8043"
              style={{ border: "solid 1px #777" }}
              width="100%"
              height={323}
              frameBorder={0}
              scrolling="no"
            />
          </div> */}
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6 items-center my-16">
          <h1 className="text-center text-lg text-[#295700] font-semibold">
            Set Appointment Date and Time
            <span className="hidden md:inline">:</span>
          </h1>
          <div className="">
            <input
              type="datetime-local"
              className="px-2 py-1 rounded-md"
              onChange={(e) => {
                setAppointmentTime(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="flex justify-center">
          {/* <Link to=""> */}
          <Link to="/selectcontactmode">
            <button
              className="text-white font-semibold bg-[#295700] rounded-md px-12 py-2 mb-16"
              onClick={setAppointment}
            >
              BOOK APPOINTMENT
            </button>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Bookappointment;
